import { render, staticRenderFns } from "./ModalsPreviewSertifikat.vue?vue&type=template&id=44c1973a&scoped=true"
import script from "./ModalsPreviewSertifikat.vue?vue&type=script&lang=js"
export * from "./ModalsPreviewSertifikat.vue?vue&type=script&lang=js"
import style0 from "./ModalsPreviewSertifikat.vue?vue&type=style&index=0&id=44c1973a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1973a",
  null
  
)

export default component.exports